import { Component } from 'react'
import { AlertTriangle } from 'lucide-react'
import { error as debugError } from '@/utils/logger'

// Defensa en profundidad independiente de cualquier fix puntual (P1,
// 2026-08-16: crash SUI 1h→4h+pan, "Cannot read properties of null (reading
// 'y')" en updateLabelPositions — ver ChartPublicPage.jsx). Antes de esto no
// existía NINGÚN error boundary en el árbol del chart: un throw durante el
// render de ChartRenderer/DrawingTools/ICTCanvas/IndicatorOverlayLabels no
// tenía nada que lo detuviera y podía dejar el resto de la pantalla muerta
// hasta F5. `key` en el caller permite forzar un remount limpio en "Reintentar"
// sin tener que tocar el resto del árbol de la página (chart, indicadores,
// header, etc. siguen vivos).
//
// `className`/`accentClassName` dejan que cada página use su propia paleta
// (el chart público vive sobre fondo verde oscuro Quantum; el privado
// ChartPage.jsx sobre blanco/gray-900 según modo claro/oscuro) sin que este
// componente compartido tenga que conocer ninguna de las dos.
export class ChartErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(err, info) {
    debugError('[ChartErrorBoundary] Error de render en el chart, contenido localmente:', err, info?.componentStack)
  }

  handleRetry = () => {
    this.setState({ hasError: false })
    this.props.onRetry?.()
  }

  render() {
    if (this.state.hasError) {
      const {
        className = 'bg-slate-50/90 dark:bg-gray-950/90',
        accentClassName = 'text-amber-500',
        textClassName = 'text-slate-700 dark:text-gray-300',
      } = this.props
      return (
        <div className={`absolute inset-0 z-30 flex items-center justify-center ${className}`}>
          <div className="text-center p-6 max-w-xs">
            <AlertTriangle size={28} className={`mx-auto mb-3 ${accentClassName}`} />
            <p className={`font-medium text-sm mb-3 ${textClassName}`}>
              Error cargando el gráfico
            </p>
            <button
              type="button"
              onClick={this.handleRetry}
              className={`text-xs px-4 py-2 rounded-lg border transition-colors ${accentClassName}`}
              style={{ borderColor: 'currentColor' }}
            >
              Reintentar
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ChartErrorBoundary
